import { render, staticRenderFns } from "./SupervisorView.vue?vue&type=template&id=8c417f32"
import script from "./SupervisorView.vue?vue&type=script&lang=js"
export * from "./SupervisorView.vue?vue&type=script&lang=js"
import style0 from "./SupervisorView.vue?vue&type=style&index=0&id=8c417f32&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports